export default class GoogleMaps {
    constructor() {
    }
    load(key, element, lat, lng, zoom) {
        this.element = element;
        return new Promise((resolve, reject) => {
            let script = document.createElement("script");
            script.async = true;
            script.defer = true;
            script.setAttribute("src", "https://maps.googleapis.com/maps/api/js?key=" + key + "&client=&v=quarterly");
            script.addEventListener("load", () => {
                resolve(this);
                this.init(element, lat, lng, zoom);
            });
            window.document.head.appendChild(script);
        });
    }
    init(element, lat, lng, zoom) {
        let options = {
            center: new google.maps.LatLng(lat, lng),
            zoom: zoom
        };
        this.map = new google.maps.Map(element, options);
        this.markers = [];
    }
    render() {
    }
    addMarker(lat, lng, label, info, icon, iconX, iconY) {
        let options = {
            position: new google.maps.LatLng(lat, lng),
            map: this.map,
            label: label
        };
        if (icon != null)
            options.icon = icon;
        if (iconX != null && iconY != null)
            options.anchorPoint = new google.maps.Point(iconX, iconY);
        let marker = new google.maps.Marker(options);
        this.markers.push(marker);
        if (info != null) {
            let content = info;
            marker.addListener("click", (e) => {
                if (this.infoWindow) {
                    this.infoWindow.unbindAll();
                    this.infoWindow.close();
                    this.infoWindow = null;
                }
                this.infoWindow = new google.maps.InfoWindow({
                    content: content,
                    position: new google.maps.LatLng(lat, lng),
                    pixelOffset: new google.maps.Size(0, -40)
                });
                this.infoWindow.open(this.map);
            });
        }
    }
    removeMarker(index) {
        if (index < 0 || index > this.markers.length - 1)
            return;
        let marker = this.markers[index];
        marker.unbindAll();
        marker.setMap(null);
        this.markers.splice(index, 1);
    }
}
